import React, { Component } from 'react' 
import { Col, Card, Row, Tabs,Pagination ,Button,message} from 'antd';
import './index.scss'
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import Default from "../../img/Default.png"
export default class Index extends Component {
    state = {
        dataList :[],
        dataInfo : {}
    }

    componentDidMount(){
       this.getListInfo()
    }
    getListInfo = (data) =>{
        let params = {
            current:1,
            size:10,
            ...data
        }
        Http.get(Request.getJobFairList(), {descs:'update_time',...params}, obj => {
            // console.log('objobjobjobj',obj);
            
            if (obj.code == 200) {
              this.setState({
                dataList: obj.data.records,
                dataInfo:obj.data
              })
            }else{
                message.error(obj.msg ? obj.msg :'请求失败')
            }
          });
    }
    renderList=()=>{
        const {dataList} =this.state
        return(
            dataList && dataList.length ? dataList.map((item,index)=>{
                
                return(
                     <div className='oneJobInfo' key = {index} onClick={()=>this.props.history.push(`/entrance/jobFairDetail/${item.id}`)}>
                        <div className="leftBox">
                            <img src={item.jobFairPictureUrl ? item.jobFairPictureUrl :Default} alt=""/>
                        </div>
                        <div className="rightBox">
                            <div className='JobNameInfo'><span>{item.name?item.name:''}</span></div>
                            <div className="regInfo">
                                举办地点: {item.venue ?item.venue:''}
                            </div>
                            <div className="timeInfo">
                                举办时间:<span> {item.holdingStartTime ? item.holdingStartTime :''}到{item.holdingEndTime ? item.holdingEndTime :''}</span>
                            </div>
                        </div>
                    </div> 
                )
                
            }):''
        )
            
        
    }
    changeSize = (page,size)=>{
        console.log('pagepagepage',page,size);
        this.getListInfo({current:page,size:size})
    }
    render() {
        const { dataInfo} = this.state
        const itemRender = (_, type, originalElement) => {
            if (type === 'prev') {
              return <a>上一页</a>;
            }
          
            if (type === 'next') {
              return <a>下一页</a>;
            }
          
            return originalElement;
          };
        return (
            <div>
                <div className="jobInfoBox">
                    <div className="jobList">
                        {this.renderList()}
                     
                    </div>
                    <div className='Pagination'>
                        <div className ='centerBox'>
                                <Pagination
                            total={dataInfo.total}
                            showSizeChanger={false}
                            showQuickJumper
                            showTotal={(total) => `共 ${total} 条`}
                            itemRender={itemRender}
                            onChange ={this.changeSize}
                            defaultCurrent={'1'}
                            />
                            <Button>确定</Button>
                        </div>
                  
                </div>
                </div>
                
            </div>
        )
    }
}
